import { buildModelManager } from "../builder.js";
const DefaultAssistantFunctionLibrarySelection = {
  __typename: true,
  id: true,
  assistantId: true,
  category: true,
  createdAt: true,
  description: true,
  functionName: true,
  isActive: true,
  parameters: true,
  permissions: true,
  priority: true,
  updatedAt: true
};
const modelApiIdentifier = "assistantFunctionLibrary";
const pluralModelApiIdentifier = "assistantFunctionLibraries";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAssistantFunctionLibrarySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAssistantFunctionLibrarySelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAssistantFunctionLibrarySelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAssistantFunctionLibrarySelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAssistantFunctionLibrarySelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAssistantFunctionLibrarySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAssistantFunctionLibrarySelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createAssistantFunctionLibrary",
    operationReturnType: "CreateAssistantFunctionLibrary",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      assistantFunctionLibrary: { required: false, type: "CreateAssistantFunctionLibraryInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAssistantFunctionLibrarySelection
  },
  {
    type: "action",
    operationName: "bulkCreateAssistantFunctionLibraries",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateAssistantFunctionLibrariesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAssistantFunctionLibrarySelection
  },
  {
    type: "action",
    operationName: "updateAssistantFunctionLibrary",
    operationReturnType: "UpdateAssistantFunctionLibrary",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      assistantFunctionLibrary: { required: false, type: "UpdateAssistantFunctionLibraryInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAssistantFunctionLibrarySelection
  },
  {
    type: "action",
    operationName: "bulkUpdateAssistantFunctionLibraries",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateAssistantFunctionLibrariesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAssistantFunctionLibrarySelection
  },
  {
    type: "action",
    operationName: "deleteAssistantFunctionLibrary",
    operationReturnType: "DeleteAssistantFunctionLibrary",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteAssistantFunctionLibraries",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertAssistantFunctionLibrary",
    operationReturnType: "UpsertAssistantFunctionLibrary",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      assistantFunctionLibrary: { required: false, type: "UpsertAssistantFunctionLibraryInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateAssistantFunctionLibraryResult": { hasReturnType: false },
      "... on UpdateAssistantFunctionLibraryResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAssistantFunctionLibrarySelection
  },
  {
    type: "action",
    operationName: "bulkUpsertAssistantFunctionLibraries",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertAssistantFunctionLibrariesInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultAssistantFunctionLibrarySelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "assistantFunctionLibraryGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AssistantFunctionLibraryManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAssistantFunctionLibrarySelection,
  operations
);
export {
  AssistantFunctionLibraryManager,
  DefaultAssistantFunctionLibrarySelection
};
//# sourceMappingURL=AssistantFunctionLibrary.js.map
